/* ACTIONS APP CONTEXT GLOBAL */
export const SET_USER_PROFILING = 'SET_USER_PROFILING';
export const SET_USER_CONTACT_INFORMATION = 'SET_USER_CONTACT_INFORMATION';
export const SET_BANNERS = 'SET_BANNERS';
export const SET_ACCOUNT = 'SET_ACCOUNT';
export const SET_LIST_ACCOUNTS = 'SET_LIST_ACCOUNTS';
export const SET_LIST_JOINT_ACCOUNTS = 'SET_LIST_JOINT_ACCOUNTS';
export const SET_JOINT_ACCOUNT = 'SET_JOINT_ACCOUNT';
export const SET_LIST_AUTONOMOUS_ACCOUNTS = 'SET_LIST_AUTONOMOUS_ACCOUNTS';
export const SET_AUTONOMOUS_ACCOUNT = 'SET_AUTONOMOUS_ACCOUNT';
export const SET_ACCOUNT_INVESTMENT = 'SET_ACCOUNT_INVESTMENT';
export const SET_LIST_INVESTMENT_ACCOUNTS = 'SET_LIST_INVESTMENT_ACCOUNTS';
export const SET_ACCOUNT_INFO = 'SET_ACCOUNT_INFO';
export const SET_BIZUM = 'SET_BIZUM';
export const SET_INACTIVE = 'SET_INACTIVE';
export const SET_USER_PENDING_TASKS = 'SET_USER_PENGING_TASKS';
export const UPDATE_USER_PENDING_TASKS = 'UPDATE_USER_PENGING_TASKS';
export const SET_USER_REQUEST_CARD = 'SET_USER_REQUEST_CARD';
export const SET_USER_REQUEST_CARD_JOINT_ACCOUNT = 'SET_USER_REQUEST_CARD_JOINT_ACCOUNT';
export const SET_WALLETS = 'SET_WALLETS';
export const SET_RIESGO = 'SET_RIESGO';
export const UPDATE_RADICAL_INVESTMENT = 'UPDATE_RADICAL_INVESTMENT';
export const UPDATE_DESCRIPTION_NAME_AUTONOMOUS = 'UPDATE_DESCRIPTION_NAME_AUTONOMOUS';
export const GENERIC_ERROR_MESSAGE = 'onboarding:error:general';
export const SET_LIST_REQUEST_CARD = 'SET_LIST_REQUEST_CARD';
export const MIN_BENEFIT_LAWYER_AMOUNT = 3000;
export const DEEP_LINK_BENEFITS_MEETING_LAYWER = 'https://www.meetinglawyers.com/apps/9e4581e5c142b6c8/open';
export const SERVICE_BENEFIT_CODE = { ML: 'ML', DA: 'DA', DX: 'DX' };
export const CODE_DOCUMENT_IDENTITY = "100";
export const CODE_DOCUMENT_RESIDENCY = "105";
export const CODE_DATE_GENERIC = "99991231"
export const CODE_DOCUMENT_TYPE_GENERIC = "999"
export const MAX_SIZE_DOCUMENT_UPLOAD = 30
export const SET_INVESTMENT_SELECTED = 'SET_INVESTMENT_SELECTED'
export const SET_MOVEMENTS_CARD_ID_SELECTED = 'SET_MOVEMENTS_CARD_ID_SELECTED'
export const SET_INVESTMENT_VALID_RAD = 'SET_INVESTMENT_VALID_RAD'
export const SET_DEPOSIT_VALID_RAD = 'SET_DEPOSIT_VALID_RAD'
export const SET_INVESTMENT_FUND_ITEM = 'SET_INVESTMENT_FUND_ITEM'
export const SET_DATA_SUB_WALLET = 'SET_DATA_SUB_WALLET'
export const SET_DATA_WALLET = 'SET_DATA_WALLET'
export const SET_WALLET_CAROUSEL_SELECTED = 'SET_WALLET_CAROUSEL_SELECTED';
export const SET_LIST_WALLETS = 'SET_LIST_WALLETS';
export const SET_POSITION_WALLET_CAROUSEL_SELECTED = "SET_POSITION_WALLET_CAROUSEL_SELECTED"
export const BENEFIT_URL_PERIODIC_ANDORRA = "https://www.diariandorra.ad/";
export const BENEFIT_URL_PERIODIC_EXPANSION = "https://compra.expansion.com/compras/lite/voucher";
export const SET_DATA_ORDER_SELECTED = "SET_DATA_ORDER_SELECTED";
export const SET_DATA_ORDER_DELETE = "SET_DATA_ORDER_DELETE"
export const SET_DATA_PORTFOLIO_INVESTMENT = "SET_DATA_PORTFOLIO_INVESTMENT"
export const SET_DATA_PORTFOLIO_LOADED = "SET_DATA_PORTFOLIO_LOADED"
export const SET_DATA_DEPOSIT_SELECTED = "SET_DATA_DEPOSIT_SELECTED"
export const SET_DATA_BIZUM_SUBS_SELECTED = "SET_DATA_BIZUM_SUBS_SELECTED"
export const SET_BIZUM_TAB_SELECTED = "SET_BIZUM_TAB_SELECTED"
export const SET_POSITION_ACCOUNT_CAROUSEL_SELECTED = "SET_POSITION_ACCOUNT_CAROUSEL_SELECTED"
export const SET_MOVEMENT_ACCOUNT_ID_SELECTED = "SET_MOVEMENT_ACCOUNT_ID_SELECTED"
export const SET_DISABLED_MENU_TRANSFER = "SET_DISABLED_MENU_TRANSFER"
export const SET_SECURE_SIMULATION = "SET_SECURE_SIMULATION"
export const SET_INSURANCE_SIMULATION = "SET_INSURANCE_SIMULATION"
export const SET_SIMULATION_LIST = "SET_SIMULATION_LIST"
export const SET_LAST_LOCATION_BEFORE_PREVIOUS_SIMULATIONS = "SET_LAST_LOCATION_BEFORE_PREVIOUS_SIMULATIONS"
export const SET_LIST_CARDS = 'SET_LIST_CARDS';
export const SET_TYPE_NEW_JOINT_ACCOUNT = "SET_TYPE_NEW_JOINT_ACCOUNT"
export const SET_ERROR_ACTIVATE_JOINT_ACCOUNT = "SET_ERROR_ACTIVATE_JOINT_ACCOUNT";
export const SET_SAVINGS = "SET_SAVINGS"
export const SET_USER_PROFILING_CONFIG = 'SET_USER_PROFILING_CONFIG';
export const SET_TYPE_GP_CARD_JOINT_ACCOUNT = "SET_TYPE_GP_CARD_JOINT_ACCOUNT";
export const SET_DATA_CLIENTS_JOINT_ACCOUNT = "SET_DATA_CLIENTS_JOINT_ACCOUNT";
export const SET_ACCOUNT_CAROUSEL_SELECTED = "SET_ACCOUNT_CAROUSEL_SELECTED";
export const SET_IS_JOINT_ACCOUNT = "SET_IS_JOINT_ACCOUNT";
export const SET_SHOW_MODAL_ACCEPT_INVITE_JOINT_ACCOUNT = "SET_SET_SHOW_MODAL_ACCEPT_INVITE_JOINT_ACCOUNTS_JOINT_ACCOUNT";
export const SET_DATA_GET_CASE_BY_RADICAL_PERSON = "SET_DATA_GET_CASE_BY_RADICAL_PERSON";
export const SET_DEPOSIT_ITEM = "SET_DEPOSIT_ITEM";
export const SET_DATA_GET_CASE_BY_RADICAL_PERSON_KIDS = "SET_DATA_GET_CASE_BY_RADICAL_PERSON_KIDS";
export const SET_INDIVIDUAL_ATRIBUTES_GET_CASE_BY_RADICAL_PERSON_KIDS = "SET_INDIVIDUAL_ATRIBUTES_GET_CASE_BY_RADICAL_PERSON_KIDS";
export const SET_DATA_CLIENTS_KIDS_ACCOUNT = "SET_DATA_CLIENTS_KIDS_ACCOUNT";
export const SET_LIST_JUNIOR_ACCOUNTS = 'SET_LIST_JUNIOR_ACCOUNTS';
export const SET_JUNIOR_ACCOUNT = 'SET_JUNIOR_ACCOUNT';
export const SET_LIST_KIDS_ACCOUNTS = 'SET_LIST_KID_ACCOUNTS';
export const SET_KIDS_ACCOUNT = 'SET_KIDS_ACCOUNT';
export const SET_ACCOUNT_KIDS_CAROUSEL_SELECTED = 'SET_ACCOUNT_KIDS_CAROUSEL_SELECTED';
export const SET_CASE_BY_RADICAL_PERSON_KIDS_SELECTED = 'SET_CASE_BY_RADICAL_PERSON_KIDS_SELECTED';
export const SET_SUB_TIPO_ALTA_BLOQUED_ACCOUNT = 'SET_SUB_TIPO_ALTA_BLOQUED_ACCOUNT';
export const SET_GOAL_CAROUSEL_SELECTED = 'SET_GOAL_CAROUSEL_SELECTED';
export const SET_LIST_GOALS = 'SET_LIST_GOALS';
export const SET_POSITION_GOAL_CAROUSEL_SELECTED = "SET_POSITION_GOAL_CAROUSEL_SELECTED"
export const SET_LIST_KIDS_CARDS = 'SET_LIST_KIDS_CARDS';
export const SET_LIST_AUTONOMOUS_CARDS = 'SET_LIST_AUTONOMOUS_CARDS';
export const SET_POSITION_ACCOUNT_KIDS_CAROUSEL_SELECTED = 'SET_POSITION_ACCOUNT_KIDS_CAROUSEL_SELECTED';
export const SET_ROUTES_FROM_HADER_MOBILE = 'SET_ROUTES_FROM_HADER_MOBILE';
export const SET_DATA_WALLET_CREDIT_ACCOUNT = 'SET_DATA_WALLET_CREDIT_ACCOUNT';
export const SET_CARD_ORIGIN = 'SET_CARD_ORIGIN';
export const SET_END_INSURANCES_RESULTS = 'SET_END_INSURANCES_RESULTS';
export const SET_DATA_PORTFOLIO_DEPOSIT = 'SET_DATA_PORTFOLIO_DEPOSIT';
export const SET_IS_ORIGIN_GP_KIDS = 'SET_IS_ORIGIN_GP_KIDS';
export const SET_PORTFOLIO_TYPE_CHILDREN_LIST = 'SET_PORTFOLIO_TYPE_CHILDREN_LIST';
export const SET_USER_KID_SELECTED = 'SET_USER_KID_SELECTED';
export const SET_PROFIL_NEW_WALLET = 'SET_PROFIL_NEW_WALLET';
export const SET_LIST_BENEFICIARIES = 'SET_LIST_BENEFICIARIES';
export const SET_OPEN_MENU_GP = 'SET_OPEN_MENU_GP';
export const SET_LIST_TOTAL_CURRENCY_MINOR_ACCOUNTS = 'SET_LIST_TOTAL_CURRENCY_MINOR_ACCOUNTS';
export const SET_CRYPTO_LIST = 'SET_CRYPTO_LIST';
export const SET_SELECTED_CRYPTO = 'SET_SELECTED_CRYPTO';
export const SET_CONTRATED_CRYPTO_LIST = 'SET_CONTRATED_CRYPTO_LIST';
export const SET_SELECTED_CONTRATED_CRYPTO = 'SET_SELECTED_CONTRATED_CRYPTO';
export const SET_CRYPTO_LIST_MYB = 'SET_CRYPTO_LIST_MYB';
export const SET_CRYPTO_VALID_RAD = 'SET_CRYPTO_VALID_RAD';
export const SET_CJ_FONDOS_VALID_RAD = 'SET_CJ_FONDOS_VALID_RAD';
export const SET_IS_UPDATE_WALLET = 'SET_IS_UPDATE_WALLET';
export const SET_DATA_KYC_LIST = 'SET_DATA_KYC_LIST';
export const SET_DATA_KYC_CLEAR = 'SET_DATA_KYC_CLEAR';
export const SET_KYC_ORIGIN_MODAL_GP = 'SET_KYC_ORIGIN_MODAL_GP';
export const SET_KYC_SELECTED_MODAL_GP = 'SET_KYC_SELECTED_MODAL_GP';
export const SET_ACCOUNT_USD = 'SET_ACCOUNT_USD';
export const SET_ATTACH_DOCUMENT_LIST = 'SET_ATTACH_DOCUMENT_LIST';
export const SET_ORIGIN_PERSONAL_INFORMATION = 'SET_ORIGIN_PERSONAL_INFORMATION';
export const SET_CONTRACT_DATA = 'SET_CONTRACT_DATA';
export const SET_DATA_DOCUMENT_IDENTITY_VALID_RAD = 'SET_DATA_DOCUMENT_IDENTITY_VALID_RAD';
export const SET_KYC_VIGENTE_VALID_RAD = 'SET_KYC_VIGENTE_VALID_RAD';
export const SET_DATA_DOCUMENT_FONDOS_VALID_RAD = 'SET_DATA_DOCUMENT_FONDOS_VALID_RAD';
export const SET_USER_LANGUAGE = 'SET_USER_LANGUAGE';
export const SET_KYC_ORIGIN_CRYPTO_OPERATIONS = 'SET_KYC_ORIGIN_CRYPTO_OPERATIONS';
export const BIZUM_LIMITS = {
  KIDS_JUNIOR_MAX: 50,
  REGULAR_MAX: 1000,
  MIN_AMOUNT: 0.5,
}
export const SET_IS_FRIENDS_AND_FAMILY = 'SET_IS_FRIENDS_AND_FAMILY';
export const TOGGLE_AMOUNT_VISIBILITY = 'TOGGLE_AMOUNT_VISIBILITY';
export const DEEP_LINK_BENEFITS_LUXAD = 'https://www.lux.ad/';
export const SET_DEPOSIT_RADICAL_IN_ACCOUNT = 'SET_DEPOSIT_RADICAL_IN_ACCOUNT';
export const SET_DEPOSIT_RADICAL_IN_ACCOUNT_5000 = 'SET_DEPOSIT_RADICAL_IN_ACCOUNT_5000';
export const SET_EXPIRED_DOCUMENTATION = 'SET_EXPIRED_DOCUMENTATION';
export const SET_EXPIRED_DOCUMENTATION_JOIN_ACCOUNTS = 'SET_EXPIRED_DOCUMENTATION_JOIN_ACCOUNTS';
export const SET_DEVICE_SELECTED = 'SET_DEVICE_SELECTED';
export const SET_IS_DEVICE_REGISTRATION = 'SET_IS_DEVICE_REGISTRATION';
export const SET_IS_AUTONOMOS = 'SET_IS_AUTONOMOS';
export const SET_IS_AUTONOMOS_ACCOUNT_INACTIVE = 'SET_IS_AUTONOMOS_ACCOUNT_INACTIVE';
export const SET_SHOW_AUTONOMOS_INACTIVE_MODAL = 'SET_SHOW_AUTONOMOS_INACTIVE_MODAL';
export const SET_IS_ORIGIN_HIRE_WALLET_END = 'SET_IS_ORIGIN_HIRE_WALLET_END';
